import { useState } from 'react';
import './ApiCard.scss';
import { useTranslation } from 'react-i18next';

interface ApiCardProps {
    image: string;
    title: string;
    description: string;
    link: string
    initialActive?: boolean;
    logoBgColor?: boolean;
    onConfigure?: () => void;
}

const ApiCard = ({
    image,
    title,
    description,
    link,
    logoBgColor = false,
    initialActive = true,
    onConfigure = () => { }
}: ApiCardProps) => {
    const [isActive, setIsActive] = useState(initialActive);
    const {t}= useTranslation();
    const handleToggle = () => {
        const newState = !isActive;
        setIsActive(newState);
    };
    
    return (
        <div className={`api-card p-3 ${isActive ? 'active' : 'inactive'}`}>
            <div className="row mb-2">
                <div className="col-10">
                    <div className={`api-card__icon-container ${logoBgColor && "bg-white-transparent"}`}>
                        <img src={image} className="api-card__icon" alt="API icon" />
                    </div>
                </div>
                <div className='col-2 text-end'>
                    <a href={link} target="_blank" className="api-card__link">
                        <i className="bi bi-box-arrow-up-right"></i>
                    </a>
                </div>
            </div>
            <div className="row mb-2 text-start">
                <div className="col-12">
                    <h4 className="api-card__title">{title}</h4>
                </div>
            </div>
            <div className="row mb-3 text-start">
                <div className="col-12">
                    <p className="api-card__description">{description}</p>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <hr className={`api-card__separator ${isActive ? 'api-card__separator--active' : 'api-card__separator--inactive'}`} />
                </div>
            </div>
            <div className="row mt-3 text-start align-items-center">
                <div className="col-6">
                    <button
                        className={`api-card__configure-btn ${isActive ? 'api-card__configure-btn--active' : 'api-card__configure-btn--inactive'}`}
                        onClick={onConfigure}
                        disabled={!isActive}
                    >
                        {t("Configure")}
                    </button>
                </div>
                <div className="col-6 d-flex justify-content-end">
                    <button
                        onClick={handleToggle}
                        className={`api-card__switch ${isActive ? 'api-card__switch--active' : 'api-card__switch--inactive'}`}
                        aria-checked={isActive}
                        role="switch"
                    >
                        <span className="api-card__switch-thumb"></span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ApiCard;